import {cn} from "@/lib/utils";

interface SectionPageProps {
    children: React.ReactNode;
    sectionType: "full" | "md" | "sm" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";
    className?: string;
}

export default function SectionPage({children, sectionType, className}: Readonly<SectionPageProps>) {
  return (
    <div className={cn(
"mx-auto px-4 w-full",
        {
        "w-full": sectionType === "full",
        "max-w-screen-md": sectionType === "md",
        "max-w-screen-sm": sectionType === "sm",
        "max-w-screen-lg": sectionType === "lg",
        "max-w-screen-xl": sectionType === "xl",
        "max-w-screen-2xl": sectionType === "2xl",
        "max-w-screen-3xl": sectionType === "3xl",
        "max-w-screen-4xl": sectionType === "4xl",
        "max-w-screen-5xl": sectionType === "5xl",
    }, className)}>
        {children}
    </div>
  );
}
